class Gemius {
	constructor() {
		this.pendingPageviews = 0;

		window.addEventListener("GemiusReady", () => {
			this.flushPageviews();
		});
	}

	pageview() {
		this.pendingPageviews++;
		this.flushPageviews();
	}

	flushPageviews() {
		if (!window.pp_gemius_identifier) return;
		if (typeof window.pp_gemius_hit !== "function") return;

		while (this.pendingPageviews > 0) {
			window.pp_gemius_hit(window.pp_gemius_identifier);
			this.pendingPageviews--;
		}
	}
}

export default new Gemius();



// WEBPACK FOOTER //
// ./src/Gemius.js